import 'rxjs/Rx';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PlanService {
    requestStatusCode: any;
    constructor(private http: HttpClient) { }
    getRequest(data) {
        return this.http.get(`/api/Request/getRequest`, {
            params: {
                REQUEST_ID: data.requestId,
                PERSON_ID: data.personId
            }, responseType: 'json', observe: 'response'
        });
    }

    getPlan() {
        return this.http.get('/api/Plan/getPlan', { responseType: 'json', observe: 'response' });
    }

    getPlanById(planId) {
        return this.http.get('/api/Plan/getPlanById', { params: { "type": planId }, responseType: 'json' });
    }

    postPersonPlan(data) {
        return this.http.post(`/api/PersonPlan/createPersonPlan`, data, { observe: 'response' });
    }

    updateRequest(data) {
        return this.http.put(`/api/Request/updateRequestForPlan`, data, { observe: 'response' });
    }

    getPersonPlanById(personId) {
        return this.http.get(`/api/PersonPlan/getPersonPlanById`, { params: { "type": personId }, responseType: 'json', observe: 'response' });
    }

    updatePersonPlan(data) {
        return this.http.put(`/api/PersonPlan/updatePersonPlan`, data, { observe: 'response' });
    }
    deletePlan(data) {
        return this.http.delete(`/api/PersonPlan/deletePersonPlanById`, { params: { "PERSON_ID": data.PERSON_ID, "PLAN_ID": data.PLAN_ID }, responseType: 'json', observe: 'response' });
    }
}



// WEBPACK FOOTER //
// ./client/views/services/plan.service.ts